// A tiny wrapper around fetch(), borrowed from
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper

export async function client(endpoint, {responseType = 'json', body, ...customConfig }) {
    let protocol;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        protocol = 'http';
    } else {
        protocol = 'https';
    }
    protocol = 'https';
    const restRoute = protocol + '://pleinair.bitage.it/index.php/api';

    const config = {
        method: body ? 'POST' : 'GET',
        ...customConfig,
        mode: 'cors',
        //cache: 'default'
        //cache: 'no-cache',
        //credentials: 'same-origin',
        //redirect: 'follow',
        //referrerPolicy: 'no-referrer',
    };

    if (body) {
        if (!config.headers) {
            const formData = new FormData();
            for (const name in body) {
                formData.append(name, body[name]);
            }
            config.body = formData;
        } else {
            var formBody = [];
            for (var property in body) {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(body[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
            config.body = formBody;
        }

    }

    let data;
    try {
        const response = await window.fetch(restRoute + endpoint, config);
        try {
            if(responseType == 'json') {
                data = await response.json();
            } else if(responseType == 'text') {
                data = await response.text();
            }
            
        } catch (err) {
            const status = await response.statusText;
            return {
                status: status
            };
        }

        if (response.ok) {
            return data;
        }
        throw new Error(response.statusText);
    } catch (err) {
        return Promise.reject(err.message ? err.message : data);
}
}

client.get = function (endpoint, customConfig = { headers: {'Content-Type': 'application/x-www-form-urlencoded'} }) {
    return client(endpoint, {...customConfig, method: 'GET'});
};

client.post = function (endpoint, body, customConfig = { headers: {'Content-Type': 'application/x-www-form-urlencoded'} }) {
    return client(endpoint, {...customConfig, body});
};

client.upload = function (endpoint, body, customConfig = {}) {
    return client(endpoint, {...customConfig, method: 'POST', body});
};
